import { findRecursive, washDataArabic, washDataArabicAlign } from '@/mm/utils.js'

export function washData_productImgText1(walkedNode) {
  console.log('washData_productImgText1');

  const ProNode = findRecursive(walkedNode.list, (item) => item._type === 'button_text_1', 'list')
  if (ProNode) {
    if (!ProNode?.actions[0].config['文字设计'].find((item) => item === 'self_textInput')) {
      ProNode?.actions[0].config['文字设计'].unshift('self_textInput')
    }
    if (!ProNode?.actions.find((item) => item === 'translate')) {
      ProNode?.actions.push('translate')
    }
  }

  // 一行两列
  const rowColNode = findRecursive(
    walkedNode.list,
    (item) => item.componentName === 'rowCol',
    'list'
  )

  if (rowColNode) {
    if (!rowColNode.actions.includes('hover')) {
      rowColNode.actions = ['design', 'hover', 'animate', 'isShow']
    }
  }

  const ArabicRule = [
    {
      flag: 'product_title_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'product_content_title_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'product_content_flag',
      dataType: 'design',
      onlyEnglish: 'title_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'product_button_flag',
      dataType: 'design',
      onlyEnglish: 'self_textAlign',
      englishTitleLeft: 'left',
      englishTitleRight: 'right'
    },
    {
      flag: 'hoverWhole',
      dataType: 'design',
      englishTitleLeft: 'self_marginLeft',
      englishTitleRight: 'self_marginRight'
    },
    {
      flag: 'hoverWhole',
      dataType: 'design',
      englishTitleLeft: 'self_paddingLeft',
      englishTitleRight: 'self_paddingRight'
    }
  ]

  ArabicRule.forEach((item) => {
    if (item.onlyEnglish) {
      washDataArabicAlign(
        walkedNode,
        item.flag,
        item.dataType,
        item.onlyEnglish,
        item.englishTitleLeft,
        item.englishTitleRight
      )
    } else {
      washDataArabic(
        walkedNode,
        item.flag,
        item.dataType,
        item.englishTitleLeft,
        item.englishTitleRight
      )
    }
  })
}
